import React, { useEffect } from "react";
import {Routes, Route} from "react-router-dom";

import {Index} from "./pages/Index";
import {Product} from "./pages/Product";
import {LoginPage} from "./pages/auth/LoginPage";
import {Profile} from "./pages/user/Profile";
import {PrivateRoute} from "./routes/PrivateRoute";
import {CategoryShow} from "./pages/category/CategoryShow";
import {ProductShow} from "./pages/product/ProductShow";
import {CartShow} from "./pages/cart/CartShow";
import { EditProfile } from "./pages/user/EditProfile";
import { UserOrders } from "./pages/user/UserOrders";
import { UserAddresses } from "./pages/user/UserAddresses";
import { UserAddresseCreate } from "./pages/user/UserAddresseCreate";
import { EditAddress } from "./pages/user/EditAddress";
import { UserLogout } from "./pages/user/UserLogout";
import { ChangePassword } from "./pages/user/ChangePassword";
import { ForgotPasswordlPage } from "./pages/auth/ForgotPasswordlPage";
import { useAppDispatch } from "./app/hooks";
import { setIsAuth } from "./features/userLogin/userLoginSlice";
import { setCartItemsCount } from "./features/cart/cartSlice";
 
function App() {
    const dispatch = useAppDispatch();

    useEffect(() => {
        const hasToken = !!localStorage.getItem('access_token');
        dispatch(setIsAuth(hasToken));

        const handler = (event: StorageEvent) => {
            if (event.key === 'access_token') {
                const tokenExists = !!localStorage.getItem('access_token');
                dispatch(setIsAuth(tokenExists));
                // Reset cart count khi logout (token bị xóa)
                if (!tokenExists) {
                    dispatch(setCartItemsCount(0));
                }
            }
        };

        window.addEventListener('storage', handler);
        return () => window.removeEventListener('storage', handler);
    }, [dispatch]);

    return (
        <>
            <Routes>
                <Route path="/" element={<Index/>}/>
                <Route path="/product" element={<Product/>}/>
                <Route path="/category/:slug" element={<CategoryShow/>}/>
                <Route path="/product/:slug" element={<ProductShow/>}/>
                <Route path="/cart" element={<CartShow/>}/>

                {/* ***********  User Navigation Routes or Protected routes ************  */}
                <Route path="/user" element={<PrivateRoute/>}>
                    <Route path="profile" element={<Profile/>}/>
                    <Route path="edit-profile" element={<EditProfile/>}/>
                    <Route path="change-password" element={<ChangePassword/>}/>
                    <Route path="orders" element={<UserOrders/>}/>
                    <Route path="addresses" element={<UserAddresses/>}/>
                    <Route path="address/create" element={<UserAddresseCreate/>}/>
                    <Route path="edit-address/:addressId" element={<EditAddress/>}/>
                    <Route path="logout" element={<UserLogout/>}/>
                </Route>

                <Route path="/login" element={<LoginPage/>}/>
                <Route path="/forgot-password" element={<ForgotPasswordlPage/>}/>
            </Routes>
        </>
    );
}

export default App;
